<div
  class="event-management-input-row"
  [ngClass]="{
    'event-management-input-row--border-top': hasBorderTop
  }"
>
  <div class="event-management-input-row__info">
    <label class="event-management-input-row__label">
      <span class="event-management-input-row__label-text">
        {{ label }}
      </span>

      <app-icon
        *ngIf="labelInfo"
        class="pointer"
        [name]="ICONS.HELP_CIRCLE_16"
        [ngbTooltip]="labelInfo"
      ></app-icon>
    </label>

    <span class="text-small text-color-light">
      {{ labelDescription }}
    </span>
  </div>

  <div class="event-management-input-row__input">
    <ng-content></ng-content>
  </div>
</div>
